import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import styles from "./WelcomeModal.module.css";
import { useLocation } from "react-router-dom";

function WelcomeModal(props) {
  const location = useLocation().pathname;
  const [restore, setRestore] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });

  const handleRestore = async () => {
    try {
      await axios({
        url: `${process.env.REACT_APP_API_PORT}/reset`,
        method: "get",
      });

      setRestore(true);
      Toast.fire({
        icon: "success",
        title: `Se restauro la base de datos! `,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {location === "/" ? (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              <h4>Bienvenidos a Paca</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Bienvenidos a nuestro sitio de e-commerse! Paca-Hack fue creada
              como el proyecto final del Coding Bootcamp de Hack Academy. Fue
              desarollada en 3 semanas por 4 estudiantes!
            </p>
            <div className="row">
              <h4>Credenciales de prueba:</h4>
              <div className="col-sm-6">
                <h5>Cliente:</h5>
                <p>
                  <strong>Email:</strong> comprador@prueba
                </p>
                <p>
                  <strong>Password:</strong> 1234
                </p>
              </div>
              <div className="col-sm-6">
                <h5>Admin:</h5>
                <p>
                  <strong>Email:</strong> admin@prueba
                </p>
                <p>
                  <strong>Password:</strong> 1234
                </p>
              </div>
              <h4>A tener en cuenta:</h4>
              <p>
                Para una mejor experiencia, recomendamos restaurar la base de
                datos antes de navegar el sitio.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={styles.btnRestore}
              onClick={() => handleRestore()}
            >
              Restaurar
            </Button>
            <Button
              className={styles.btn}
              href="https://pacahack-admin.vercel.app"
            >
              Panel de Admin
            </Button>
            <Button className={styles.btn} onClick={props.onHide}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <></>
      )}{" "}
    </>
  );
}

export default WelcomeModal;
